import React, { FC, useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { authApi, landingPagesApi } from 'api';
import { RouterUrlParams } from 'App';
import { useAuth } from 'contexts/authContext';
import { PageLoading } from 'components/PageLoading';
import { capitalizeWord } from 'utils/helpers';
import { useGlobal } from 'contexts/globalContext';
import { useTranslation } from 'react-i18next';

export enum ExternalAuthType {
	google = 'google',
	microsoft = 'microsoft',
}

const ExternalAuth: FC = () => {
	const { authenticate } = useAuth();
	const { toastRef } = useGlobal();
	const { t } = useTranslation();
	const { type } = useParams() as RouterUrlParams<ExternalAuthType>;
	const { search } = useLocation();
	const queryParams = Object.fromEntries(new URLSearchParams(search).entries());
	const navigate = useNavigate();

	// const { mutateAsync: validateExternalAuth } = useMutation(
	// 	['afterAuth'],
	// 	({ token, headers }: { token: string; headers: any }) => authApi.finishExternalAuth(token, headers)
	// );

	const { mutateAsync: joinProgramMutateAsync } = useMutation(
		(data: { organizationName: string; programName: string }) =>
			landingPagesApi.joinProgram(data.organizationName, data.programName, true),
		{
			onSuccess: () => {
				// toastRef?.current?.show({ severity: 'success', detail: 'Dołączyłeś do programu' });
			},
		}
	);

	const [runLogin, setRunLogin] = useState(false);
	const login = useCallback(
		() => {
			if (!runLogin) {
				setRunLogin(true);
				// const additionalData = window.localStorage.getItem(`${type}-auth-data`);
				if (queryParams.accessToken) {
					try {
						authenticate(
							{
								refreshToken: queryParams.refreshToken,
								accessToken: queryParams.accessToken,
							},
							() => {
								const programNameFromLocalStorage = window.localStorage.getItem('programName');
								if (programNameFromLocalStorage) {
									const [organizationName, programName] = programNameFromLocalStorage.split('/');
									joinProgramMutateAsync({ organizationName, programName }).then(() => {
										navigate({ pathname: `/${programNameFromLocalStorage}` });
										window.localStorage.removeItem('programName');
									});
								} else {
									navigate({ pathname: '/', search });
								}
							}
						);
					} catch (errror) {
						navigate('/login', { replace: true });
					}
				}
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[runLogin, queryParams]
	);

	useEffect(() => {
		if (queryParams.error) {
			toastRef?.current?.show({
				severity: 'error',
				life: 3000,
				summary: t(`misc.error`),
				detail: t('linkedAccount.auth.consentNotObtained'),
			});
			navigate({ pathname: '/' });
		} else {
			login();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [queryParams]);

	return <PageLoading text={`Logowanie ${capitalizeWord(type)}`} />;
};

export default ExternalAuth;
